import React from 'react'
import { Link} from 'gatsby'
import { LinkResolver } from '@utils/LinkResolver'

const RelatedContent = ({relatedContent}) => {
    if (relatedContent == null) return null
    return (
        <div>
        <h3 className="h4 font-weight-bold">Related Research Division Content</h3>
        <Link to={LinkResolver(relatedContent._meta)}>{relatedContent.title}</Link>
        </div>
    )  
}

export default RelatedContent;